import awsEBSOverview from '../solutions/aws/objects/dashboards/ebs/overview.json';
import awsEC2Overview from '../solutions/aws/objects/dashboards/ec2/overview.json';
import awsEFSOverview from '../solutions/aws/objects/dashboards/efs/overview.json';
import awsELBOverview from '../solutions/aws/objects/dashboards/elb/overview.json';
import awsS3Overview from '../solutions/aws/objects/dashboards/s3/overview.json';
import aiopsProblems from '../solutions/aiops/objects/dashboards/problems/problemsOverview.json';
import aiopsSaas from '../solutions/aiops/objects/dashboards/saas/overview.json';
import aiopsIncidents from '../solutions/aiops/objects/dashboards/incidents/incidentsOverview.json';
import apmOverview from '../solutions/apm/objects/dashboards/overview/overview.json';
import cost from '../solutions/cost/dashboards/overview/overview.json';

//azure
import azureDiskOverview from '../solutions/azure/objects/dashboards/disk/overview.json';
import azureLBOverview from '../solutions/azure/objects/dashboards/lb/overview.json';
import azureVMOverview from '../solutions/azure/objects/dashboards/vm/overview.json';
// The only dashboards that are supposed to shown in production
export default [
  // solutions
  cost,
  awsEBSOverview,
  awsEC2Overview,
  awsEFSOverview,
  awsELBOverview,
  awsS3Overview,
  aiopsProblems,
  aiopsSaas,
  aiopsIncidents,
  apmOverview,
  //azure dashboards
  azureDiskOverview,
  azureLBOverview,
  azureVMOverview,
];
